import styled from 'styled-components';
import { scrollX } from '@finect/tabular-utils/scrollX';
export var Inner = styled.div.withConfig({
  displayName: "Inner",
  componentId: "sc-4nwdos-0"
})(["", ""], scrollX);